/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import axios from 'axios';
window.axios = axios;

// Setzen Sie die Basis-URL für alle API-Anfragen
// Build (production): use explicit VITE_API_BASE_URL if provided; else fall back to absolute origin + /api
// Dev: default to '/api' (works with Vite proxy) unless VITE_API_BASE_URL is set
const resolvedBaseUrl = (() => {
    const envUrl = import.meta.env.VITE_API_BASE_URL;
    const prodUrl = import.meta.env.VITE_API_BASE_URL_PROD;
    // Prefer explicit PROD override when building for production
    if (import.meta.env.PROD && prodUrl && typeof prodUrl === 'string' && prodUrl.trim().length) {
        return prodUrl.trim();
    }
    if (envUrl && typeof envUrl === 'string' && envUrl.trim().length) return envUrl.trim();
    if (import.meta.env.PROD) {
        try {
            const origin = window?.location?.origin || '';
            if (origin) return `${origin.replace(/\/$/, '')}/api`;
        } catch (_) {}
        return '/api';
    }
    return '/api';
})();
axios.defaults.baseURL = resolvedBaseUrl;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Interceptor für 401 Fehler (nicht autorisiert)
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            // Überprüfen, ob wir bereits auf der Login-Seite sind
            const currentPath = window.location.pathname;
            if (currentPath !== '/login' && !currentPath.includes('/login')) {
                // Token ist abgelaufen oder ungültig - Benutzer abmelden
                localStorage.removeItem('token');
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

// Token hinzufügen, falls vorhanden
const token = localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
